import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {FilterTag} from './FilterTag';
import humanize from 'humanize-string';
import {formatHumanName} from '../lib/formaters';
import {paymentMethodLabels} from 'lib/labels';

type queryFilters = Record<string, string | boolean | null | undefined>;
type filters = Record<string, string>;

type Props = {
  queryFilters: queryFilters;
  onClose: (key: string) => void;
  defaultQuery?: string;
  filters: filters;
  accountId: string;
};
const StyledContainer = styled.div`
  margin-bottom: 20px;
`;

export const FilterList: React.FC<Props> = ({
  queryFilters,
  filters,
  defaultQuery,
  onClose,
  accountId
}) => {
  const handleOnClose = (key: string) => onClose(key);

  const humanizeValue = (key: string, value: string) => {
    switch (key) {
      case 'riskProfile':
        return humanize(value);
      case 'billingPlan':
        return humanize(value).toUpperCase();
      case 'accountExecutive':
        return formatHumanName(value);
      case 'paymentMethodMethod':
        return paymentMethodLabels[value];
      default:
        return value;
    }
  };

  const tags = Object.entries(queryFilters)
    .filter(
      ([key, value]) => value !== undefined && value !== null && value !== '' && key !== 'createdAt'
    )
    .map(([key, value]) => {
      return (
        filters.hasOwnProperty(key) && (
          <FilterTag
            fieldName={key}
            value={humanizeValue(key, value as string)}
            filters={filters}
            queryFilters={queryFilters}
            handleOnClose={handleOnClose}
            accountId={accountId}
          />
        )
      );
    });

  return (
    <StyledContainer>
      {tags}
      {tags.length ? <Link to={defaultQuery || '#'}>Clear all</Link> : null}
    </StyledContainer>
  );
};
